var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InputMoney',{attrs:{"label":"Preço","name":"value_cash","errors":_vm.errors},model:{value:(_vm.value_cash),callback:function ($$v) {_vm.value_cash=$$v},expression:"value_cash"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-598c78a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/carrefour/rules/AVista.vue
// module id = 85kp
// module chunks = 101